import { useMutation } from 'react-query';
import { putCampaign, CampaignPayload } from '../request';

export const usePutCampaign = () => {
  const {
    mutate,
    isLoading,
  } = useMutation(
    ({
      campaignId,
      payload,
    }: {
      campaignId: string;
      payload: CampaignPayload;
    }) => putCampaign(campaignId, payload)
  );

  return { mutate, isLoading };
};
